import { css } from "../../../../styled-system/css";

export const styles = {
  root: () =>
    css({
      display: "flex",
      justifyContent: "center",
      gap: "baseUnit.mobile1",
      desktop: {
        gap: "baseUnit.mobile2",
      },
    }),
  counterBox: () =>
    css({
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      textAlign: "center",
      borderRadius: "6px",
      width: "100%",
      height: "172px",
      backgroundColor: "backgroundGrey",
      paddingY: "baseUnit.mobile2",
      paddingX: "baseUnit.mobile1",
      mobile: {
        padding: "baseUnit.mobile2",
        width: "154px",
        height: "236px",
      },
    }),
  labelSection: () =>
    css({
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "4px",
      height: "48px",
      "& span": {
        width: "60%",
      },
    }),
  valueSection: () =>
    css({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "& span": {
        width: "60%",
      },
    }),
  linkSection: () =>
    css({
      display: "flex",
      flexDirection: "column-reverse",
      alignItems: "center",
      height: "48px",
      "& span": {
        width: "80%",
      },
    }),
};
